import { ReactNode, useState, useEffect } from "react";
import Navbar from "components/Organisms/Navbar";
import LayoutContent from "components/Organisms/LayoutContent";
import { DatastoreProvider } from "contexts/datastores/datastores";
import { StyledWrapper } from "./styles";
import dynamic from "next/dynamic";
import { useOrientation } from "react-use";

const DynamicSideMenu = dynamic(() => import("components/Organisms/SideMenu"), {
  ssr: false,
});

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { type } = useOrientation();
  const [isLandscape, setIsLandscape] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    setIsLandscape(type === "landscape-primary");
  }, [type]);

  if (!mounted) {
    return null;
  }

  return (
    <StyledWrapper className="h-screen color-propagation">
      {isLandscape ? (
        <>
          <DatastoreProvider>
            <div className="pb-1">
              <Navbar />
            </div>
            <LayoutContent className="flex-grow relative">
              {children}
            </LayoutContent>
          </DatastoreProvider>
          <DynamicSideMenu />
        </>
      ) : (
        <div className="w-full h-0 pb-[178%] relative">
          <img
            src="https://media.giphy.com/media/PfY4nKis93ZHXMywps/giphy.gif"
            alt="Rotate device"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      )}
    </StyledWrapper>
  );
};

export default Layout;
